import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '1.5rem',
  },
  body: {
    marginTop: '2rem',
  },
  message: {
    margin: '16px 0 8px 0',
  },
  text: {
    color: theme.palette.text.primary,
  },
  actions: {
    marginTop: '2rem',
  },
}));

export type EmptyResultViewProps = {
  message: string;
  title?: string;
  suggestion?: string;
  actionsChild?: ReactNode;
  imageChild?: ReactNode;
};

export const EmptyResultView = ({
  message,
  title,
  suggestion = '',
  actionsChild,
  imageChild,
}: Readonly<EmptyResultViewProps>) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root} data-testid="empty-result-view">
      <Box className={classes.body} data-testid="empty-result-body">
        {title && (
          <Typography data-testid="no-results-text" variant="body1">
            {title}
          </Typography>
        )}
        <Typography
          data-testid="empty-result-message-text"
          className={`${classes.message} ${classes.text}`}
          variant="h3"
        >
          {message}
        </Typography>
        <Typography
          data-testid="empty-result-suggestion-text"
          className={classes.text}
          variant="body1"
        >
          {suggestion}
        </Typography>
        <Box
          className={classes.actions}
          data-testid="empty-result-child-element"
        >
          {actionsChild}
        </Box>
      </Box>
      {imageChild}
    </Box>
  );
};
